var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFilter = function SvgIconsFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.454 2l-.05.002c-.354.037-.536.459-.297.739l3.529 4.13V9.65c0 .17.097.326.25.402l1.819.9.048.02c.29.106.61-.106.61-.423V6.871l3.528-4.13c.25-.293.04-.741-.347-.741h-9.09zm8.11.9L6.56 6.416l-.038.051c-.045.072-.07.155-.07.24V9.82l-.908-.45V6.707l-.005-.064c-.012-.083-.047-.162-.103-.227L2.434 2.9h7.13z"
  })));
};
export default SvgIconsFilter;